import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client.js";

export function useReviewPermissions(reviewId: string) {
  return useQuery({
    queryKey: ["review-permissions", reviewId],
    queryFn: () => api.reviewPermissions(reviewId),
    staleTime: Number.POSITIVE_INFINITY,
  });
}
